<app-modal #modal [wide]="true" (dismissed)="userId = undefined">
  @if (userId) {
    @if (balances) {
      <div class="mb-4">
        <app-account-balances-detail
          [accounts]="balances.accounts"
          [balances]="balances.balances"
          [userId]="userId"></app-account-balances-detail>
      </div>
    }

    <app-payouts-overview
      [accounts]="accounts"
      [filterUserId]="userId"></app-payouts-overview>
  }
</app-modal>
